export function addHours(date: Date, h: number) {
  if (!h) return date;

  // clone date and set new date
  const newDate = new Date(date);
  newDate.setTime(date.getTime() + h * 60 * 60 * 1000);
  return newDate;
}
